<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import UtilService from "@/services/UtilService";

export default {
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router
        .push(`/apps/users/edit/${this.params.data.Id}`)
        .catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `Are you sure to delete ${this.params.data.Name}?`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if(this.params.data.FirebaseUid){
        const TOKEN = $cookies.get('TOKEN');
        UserService.deleteFirebaseUser(this.params.data.FirebaseUid, TOKEN)
          .then((response) => {
            const data = response.data;
            if(data && data.status == 0){
              UtilService.notifyErrorAlert(this.$vs, (data.err && data.err.name === 'TokenExpiredError')? 'Token is expired. Please logout and login again and try.' : 'Failed to delete user.');
            } else {
              UserService.delete(this.params.data.Id)
                .then(() => {
                  UtilService.notifySuccessAlert(this.$vs, 'The selected user is successfully deleted.');
                })
                .catch(e => {
                  console.log(e);
                });
            }
          })
          .catch(e => {
            console.log(e);
            UtilService.notifyErrorAlert(this.$vs, 'Failed to delete user.');
          });
      } else {
        UtilService.notifyErrorAlert(this.$vs, 'This user is not added in firebase.');
      }
    }
  }
};
</script>
